const Home = () => (
<main>
    <h1>Welcome to Curty's Kooky</h1>
    <p style={{
    fontSize: "1.2rem",
    maxWidth: "600px",
    margin: "2rem auto",
  }}>
      Indulge in Curty's Kooky — your go-to bakery for bold flavors, homemade goodness, and cookies so good they’re downright kooky! Explore our signature treats, discover recipes, or order catering for your next event.
    </p>
  </main>
);

export default Home;